export const exshiftAssignApi = {
    heading:[

        {
            head:"Employee ID"
        },
        {
            head:"Employee Name"
        },
        {
            head:"Exception Type"
        },
        {
            head:"Start Time"
        },       
        {
            head:"End Time"
        },       
        {
            head:"Remarks"
        },
    ],
    data:[
       {
        tickmark:false,
        empid:1138,
        empname:"Shaheda Iqbal",
        exceptiontype:"Rainy Day",
        starttime:"7:00:AM",
        endtime:"11:00:AM",
        remarks:"permitted"
    },
       {
        tickmark:false,
        empid:1139,
        empname:"Shaheda Iqbal",
        exceptiontype:"Rainy Day",
        starttime:"7:00:AM",
        endtime:"11:00:AM",
        remarks:"permitted"
    },
       {
        tickmark:false,
        empid:1140,
        empname:"Shaheda Iqbal",
        exceptiontype:"Rainy Day",
        starttime:"7:00:AM",
        endtime:"11:00:AM",
        remarks:"permitted"
    },
     
       
     
       
    ]
}